import { render } from "./DashboardCreateGiftCard.vue?vue&type=template&id=5fb43f59&scoped=true"
import script from "./DashboardCreateGiftCard.vue?vue&type=script&lang=js"
export * from "./DashboardCreateGiftCard.vue?vue&type=script&lang=js"

import "./DashboardCreateGiftCard.vue?vue&type=style&index=0&id=5fb43f59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb43f59"]])

export default __exports__